import {useRetarder} from '@hconnect/tuc-processes/fields/retarder/useRetarder'
import {ControlledSelect} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

/**
 * Reusable Retarder Field component for RMC orders
 * Uses the retarder business logic from orderProcessesPackage
 */
export const RetarderField: React.FC = () => {
  const {t} = useTranslation()
  const {retarder, setRetarder, retarderConfiguration} = useRetarder()

  const handleRetarderChange = (value: string | number) => {
    const numericValue = typeof value === 'string' ? parseFloat(value) : value
    setRetarder(numericValue)
  }

  // Generate retarder options based on configuration
  const generateRetarderOptions = (): Array<{value: number; label: string}> => {
    if (!retarderConfiguration?.isEnabled) return []

    const options: Array<{value: number; label: string}> = []
    const {min, max, step} = retarderConfiguration

    // Default option for 0 hours
    options.push({
      value: 0,
      label: t('orderIntake.rmc.steps.shared.retarder.notNeeded', 'not needed')
    })

    // Generate options for values > 0
    for (let value = min; value <= max; value += step) {
      if (value > 0) {
        options.push({
          value,
          label: `${value} ${retarderConfiguration.uom}`
        })
      }
    }

    return options
  }

  const retarderOptions = generateRetarderOptions()

  // Only render if retarder is enabled in configuration
  if (!retarderConfiguration?.isEnabled) {
    return null
  }

  return (
    <div
      style={{
        position: 'relative',
        isolation: 'isolate',
        zIndex: 1
      }}
    >
      <ControlledSelect
        name="retarder"
        label={t('orderIntake.rmc.steps.shared.retarder.label', 'Retarder delay time')}
        value={retarder?.retarder ?? 0}
        onChange={handleRetarderChange}
        values={retarderOptions}
        error={undefined}
        className="w-full"
        data-test-id="retarder-select"
      />
    </div>
  )
}
